import { Mutation } from '@apollo/client/react/components';
import type { MutationFunction as MutationFn } from '@apollo/client/react/types/types';
import * as React from 'react';
import GroupOptionsCheckbox from '../GroupOptionsCheckbox';
import SET_REQUEST_TO_JOIN_MUTATION from './SET_REQUEST_TO_JOIN_MUTATION.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from '@apollo/client';
import { setRequestToJoin, setRequestToJoinVariables } from './__generated__/setRequestToJoin';

export type SetRequestToJoinMutationFn = MutationFn<setRequestToJoin, setRequestToJoinVariables>;

type Props = {
  checked: boolean;
  requestToJoinEnabledRecommendation: string;
  onChange: (e: React.MouseEvent, setRequestToJoin: SetRequestToJoinMutationFn) => void;
  disabled: boolean;
};

const RequestToJoinCheckbox = ({
  checked,
  requestToJoinEnabledRecommendation,
  onChange,
  disabled,
}: Props) => (
  <Mutation<setRequestToJoin, setRequestToJoinVariables>
    mutation={SET_REQUEST_TO_JOIN_MUTATION}
    onCompleted={() => ToastActions.showSuccessToast('Saved')}
    onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}
  >
    {(setRequestToJoinMutation) => (
      <GroupOptionsCheckbox
        label={'Require approval to join'}
        sublabel={
          'Only people who you add or approve will be able to join this class. Anyone added by your school will be approved automatically.'
        }
        checked={checked}
        schoolDefault={requestToJoinEnabledRecommendation}
        onChange={(e) => onChange(e, setRequestToJoinMutation)}
        disabled={disabled}
      />
    )}
  </Mutation>
);

export default RequestToJoinCheckbox;
